
import $ from 'jquery';

import {validEmail, validPasswordCharacters} from './Validation.js';
import {preventNumberInput} from './Util.js';


$( document ).ready( function() {

	// Replaces dynamicUserSpaceRemover in Templates
	$( document ).on( 'input keyup blur', '.acl_js_input--remove_spaces', function() {
		$( this ).val( $( this ).val().replace( /\s/g, '' ) );
	} );

	// Prevent Numeric Input.
	$( document ).on( 'input keydown keyup', '.acl_js_input--prevent_number_input', (ev) => preventNumberInput(ev) );

	// Validate Password Inputs.
	$( document ).on( 'input propertychange blur', '.acl_js_input_validate--password', function() {

		if ( $(this).val() === '' ) {
			return;
		}

		const isValid = validPasswordCharacters( $( this ).val() );

		if ( isValid ) {
			$(this).closest('.input_row').find('.input_row_message').hide();
			$(this).closest('.account_section').find('button').prop('disabled', false);
		} else {
			$(this).closest('.input_row').find('.input_row_message').show();
			$(this).closest('.account_section').find('button').prop('disabled', true);
		}
	});


	// Validate E-Mail Inputs.
	$( document ).on( 'blur', '.acl_js_input_validate--email', function() {
		if ( $(this).val() === '' ) {
			return;
		}

		const isValid = validEmail( $(this).val() );
		if ( isValid ) {
			$(this).closest('.input_row').find('.input_row_message').hide();
			$(this).closest('.account_section').find('button').prop('disabled', false);
		} else {
			$(this).closest('.input_row').find('.input_row_message').show();
			$(this).closest('.account_section').find('button').prop('disabled', true);
		}
	});
});
